export function HeaderActions({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-row-reverse items-center justify-end gap-1 md:flex-row md:gap-2 print:hidden">
      {children}
    </div>
  );
}
